import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    widgets: null,
    loading: false,
    settings: null
};

const constantsSlice = createSlice({
    name: 'constants',
    initialState,
    reducers: {
        toggleConstants(state, action) {
            console.log('entered to widgets',action)

            if (action.payload.widgets) {
                state.widgets = action.payload.widgets;
            }
        },
        toggleSettings(state, action) {


            if (action.payload.settings) {
                state.settings = action.payload.settings;
            }
        },
        toggleLoading(state, action) {
            console.log('entered to loading widget',action)

            if (action.payload) {
                state.loading = action.payload.loading;
            }
        },
    }
});

export const constantsActions = constantsSlice.actions;
export default constantsSlice.reducer;
